module.exports = __webpack_public_path__ + "static/media/TA_Logo.4734f26f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/TA_Logo.svg
// module id = 610
// module chunks = 0